import React from 'react';
import ProductCard from '../ProductCard/ProductCard';

export default function ProductList({ products, onAddToCart }) {
  return (
    <div className="product-list">
      {products.map((p) => (
        <ProductCard key={p.id} product={p} onAddToCart={onAddToCart} />
      ))}
    </div>
  );
}
